module.exports = __webpack_public_path__ + "media/img/vca/nomh5-03fcc3ba4a2b94658b27a5cec3d7a016.png";